(() => {
  const gate = document.querySelector('[data-password-gate]');
  if (!gate) return;

  const sheet = gate.querySelector('[data-gate-sheet]');
  const openButton = gate.querySelector('[data-gate-open]');
  const edgeTrigger = gate.querySelector('[data-gate-edge]');
  const closeButton = gate.querySelector('[data-gate-close]');
  const backdrop = gate.querySelector('[data-gate-backdrop]');
  const tabs = [...gate.querySelectorAll('[data-gate-tab]')];
  const panels = [...gate.querySelectorAll('[data-gate-panel]')];
  const mobileQuery = window.matchMedia('(max-width: 760px)');
  const mobileOpenDelay = Number.parseInt(gate.dataset.mobileOpenDelay || '0', 10);
  let previouslyFocused = null;
  let previousBodyOverflow = '';
  let focusTimer = null;
  let mobileTimer = null;
  let touchStartX = null;
  let touchStartY = null;

  sheet.inert = true;

  const activateTab = (name, focus = false) => {
    tabs.forEach((tab) => {
      const isActive = tab.dataset.gateTab === name;
      tab.setAttribute('aria-selected', String(isActive));
      tab.tabIndex = isActive ? 0 : -1;
      if (isActive && focus) tab.focus();
    });
    panels.forEach((panel) => { panel.hidden = panel.dataset.gatePanel !== name; });
  };

  const openGate = (focus = true) => {
    if (gate.classList.contains('is-open')) return;
    window.clearTimeout(mobileTimer);
    previouslyFocused = document.activeElement;
    previousBodyOverflow = document.body.style.overflow;
    sheet.inert = false;
    gate.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (focus) focusTimer = window.setTimeout(() => sheet.querySelector('[aria-selected="true"]')?.focus(), 820);
  };

  const closeGate = () => {
    if (!gate.classList.contains('is-open')) return;
    window.clearTimeout(mobileTimer);
    window.clearTimeout(focusTimer);
    gate.classList.remove('is-open');
    sheet.inert = true;
    document.body.style.overflow = previousBodyOverflow;
    if (previouslyFocused instanceof HTMLElement) previouslyFocused.focus();
  };

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => activateTab(tab.dataset.gateTab));
    tab.addEventListener('keydown', (event) => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      const direction = event.key === 'ArrowRight' ? 1 : -1;
      const next = tabs[(index + direction + tabs.length) % tabs.length];
      activateTab(next.dataset.gateTab, true);
    });
  });

  openButton?.addEventListener('click', () => { activateTab('member'); openGate(); });
  edgeTrigger?.addEventListener('pointerenter', () => openGate(false));
  gate.addEventListener('touchstart', (event) => {
    const touch = event.touches[0];
    const startedOnControl = event.target.closest('button, input, a, [role="tab"]');
    if (!touch || startedOnControl || gate.classList.contains('is-open')) {
      touchStartX = null;
      touchStartY = null;
      return;
    }
    touchStartX = touch.clientX;
    touchStartY = touch.clientY;
  }, { passive: true });
  gate.addEventListener('touchend', (event) => {
    const touch = event.changedTouches[0];
    const isMobile = mobileQuery.matches;
    const startX = touchStartX;
    const startY = touchStartY;
    touchStartX = null;
    touchStartY = null;
    if (!touch || startX === null || startY === null || !isMobile) return;

    const horizontalTravel = Math.abs(touch.clientX - startX);
    const upwardTravel = startY - touch.clientY;

    if (upwardTravel < 56 || upwardTravel < horizontalTravel * 1.25) return;
    activateTab('signup');
    openGate(false);
  }, { passive: true });
  gate.addEventListener('touchcancel', () => {
    touchStartX = null;
    touchStartY = null;
  }, { passive: true });
  closeButton?.addEventListener('click', closeGate);
  backdrop?.addEventListener('click', closeGate);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && gate.classList.contains('is-open')) closeGate();
  });

  const memberError = gate.querySelector('[data-member-error]');
  const hasMessage = gate.querySelector('.fm-gate__message');
  if (memberError) activateTab('member');
  if (hasMessage) window.setTimeout(() => openGate(), 0);
  if (!hasMessage && mobileQuery.matches && mobileOpenDelay > 0) {
    mobileTimer = window.setTimeout(() => {
      activateTab('signup');
      openGate(false);
    }, mobileOpenDelay);
  }
})();
